import React from 'react';
import { useRouter } from 'next/router';
import { Dropdown, DropdownOptions } from '@components/ui-old/dropdown';
import { useLogoutMutation } from '@framework/auth/use-logout';
import { useTranslation } from 'next-i18next';
import { IoHomeOutline, IoCartOutline, IoPersonOutline, IoSettingsOutline, IoLogOutOutline } from 'react-icons/io5';
import { MdOutlineLocationOn } from "react-icons/md";
import { AiOutlineShop } from 'react-icons/ai';
import { ROUTES } from '@utils/routes';
interface AuthDropdownMenuProps {
  onClose: () => void;
}
const AuthDropdownMenu: React.FC<AuthDropdownMenuProps> = ({
  onClose
}) => {
  const router = useRouter();
  const {
    mutate: logout
  } = useLogoutMutation();
  const {
    t
  } = useTranslation('common');
  const options: DropdownOptions[] = [{
    label: t('text-dashboard'),
    value: 'profile',
    icon: <IoHomeOutline className="w-5 h-5" />
  }, {
    label: t('text-orders'),
    value: 'orders',
    icon: <IoCartOutline className="w-5 h-5" />
  }, {
    label: t('text-retail'),
    value: 'retail',
    icon: <AiOutlineShop className="w-5 h-5" />
  }, {
    label: t('text-my-address'),
    value: 'my-address',
    icon: <MdOutlineLocationOn className="w-5 h-5" />
  }, {
    label: t('text-account-details'),
    value: 'account-details',
    icon: <IoPersonOutline className="w-5 h-5" />
  }, {
    label: t('text-change-password'),
    value: 'change-password',
    icon: <IoSettingsOutline className="w-5 h-5" />,
    dividerAfter: true
  }, {
    label: t('text-logout'),
    value: 'logout',
    icon: <IoLogOutOutline className="w-5 h-5" />,
    danger: true
  }];
  const handleOptionSelect = (option: DropdownOptions) => {
    switch (option.value) {
      case 'profile':
        router.push(ROUTES.ACCOUNT);
        break;
      case 'orders':
        router.push(ROUTES.ORDERS);
        break;
      case 'retail':
        router.push(ROUTES.RETAIL);
        break;
      case 'my-address':
        router.push(ROUTES.MY_ADDRESS);
        break;
      case 'account-details':
        router.push(ROUTES.ACCOUNT_DETAILS);
        break;
      case 'change-password':
        router.push(ROUTES.CHANGE_PASSWORD);
        break;
      case 'logout':
        logout();
        break;
      default:
        break;
    }
    onClose();
  };
  return <Dropdown options={options} selectedOption="" onOptionSelect={handleOptionSelect} onClose={onClose} className="mt-1 w-42 bg-white dark:bg-zinc-950 border rounded-xl shadow-xl" data-sentry-element="Dropdown" data-sentry-component="AuthDropdownMenu" data-sentry-source-file="auth-dropdown-menu.tsx" />;
};
export default AuthDropdownMenu;